import * as bootstrap from "bootstrap";

// Expose the npm copy of Bootstrap globally (window.bootstrap.Modal, etc.).
// Do not load @/assets/vendor/js/bootstrap.js alongside: it embeds a second
// copy of Bootstrap whose data-api listeners register twice, producing double
// modal backdrops and desynchronized Modal instances.
window.bootstrap = bootstrap;
